export default "__VITE_ASSET__ee0f52ec__"